const tables = (): void => {
  const tableHeading = document.querySelectorAll(
    '[data-element="table-heading"]'
  );

  tableHeading.forEach((heading) => {
    const columnNumber = heading.getAttribute('data-heading-ref'),
      columnHeading = heading.innerHTML,
      rowHeadings = document.querySelectorAll(
        '[data-column-ref="' + columnNumber + '"]'
      );
    rowHeadings.forEach((rowHeading) => {
      if (rowHeading.innerHTML) {
        rowHeading.innerHTML =
          '<span class="cell__heading">' +
          columnHeading +
          '</span>' +
          rowHeading.innerHTML;
      }
    });
  });
};

export default tables;
